export const MEDICAL_ADMINISTRATIVE_WITH_ACTE_REMUNERATION_PREFIX = '254';
export const MEDICAL_ADMINISTRATIVE_WITH_MIXTE_REMUNERATION_PREFIX = '295';

export const MEDICAL_ADMINISTRATIVE_LUMPSUM_CODES = ['xxx255'];

export const isMedicalAdministrativeCode = (code) => MEDICAL_ADMINISTRATIVE_LUMPSUM_CODES.includes(code);
